import BrandList from "../pre-delivery-ins-vehicle-brand-list";
import ModelsList from "../pre-delivery-ins-vehicle-model-list";

export const STEP_NAMES = {
    Brand: "brand",
    Model: "model"
};

export const STEP_LIST = [
    {
        name: STEP_NAMES.Brand,
        Component: BrandList,
        reduxStateKey: STEP_NAMES.Brand,
        displayName: "Brand",
        heading: "Select car brand"
    },
    {
        name: STEP_NAMES.Model,
        Component: ModelsList,
        reduxStateKey: STEP_NAMES.Model,
        displayName: "Model",
        heading: "Select car model"
    }
];
